import { render, staticRenderFns } from "./Affiliates_Holding_Page.vue?vue&type=template&id=e7cfa880&scoped=true"
import script from "./Affiliates_Holding_Page.vue?vue&type=script&lang=js"
export * from "./Affiliates_Holding_Page.vue?vue&type=script&lang=js"
import style0 from "./Affiliates_Holding_Page.vue?vue&type=style&index=0&id=e7cfa880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cfa880",
  null
  
)

export default component.exports